// when merge to 2.1.0 or higher, override this hook with the one from the new version
const useTheme = () => {
    return {
        isThemeDark: false,
        isThemeBase: true,
        theme: 'base',
    };
};

export default useTheme;
